module.exports = __webpack_public_path__ + "static/media/codechef.cafd0bcd.png";